var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStats = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.559 14.797a.794.794 0 0 1-1.588 0v-9a.794.794 0 0 1 1.588 0v9ZM9.794 14.798a.794.794 0 1 1-1.588 0V3.202a.794.794 0 0 1 1.588 0v11.596ZM14.03 14.797a.794.794 0 0 1-1.589 0v-7a.794.794 0 0 1 1.589 0v7Z"
})));
export default SvgStats;